/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function() {
  /* $(".spr-review-header-title").click(function() {
     alert("hi");
  });*/
  
  $('.header-gold-text-slider ul').slick({
    dots: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  
  $(document).on('click', '.spr-summary-actions-togglereviews', function(){
      $(".spr-content .spr-reviews").toggle();
  });
  
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("Je moet akkoord gaan met de algemene voorwaarden om verder te gaan.");
      return false;
    }
  });
  
  $('.header__search-toggle').on('click', function(e) {
    $('.header__search-bar-wrapper').toggleClass("_expand");
    $('.header__action-item--search').toggleClass("_expand");
    e.preventDefault();
  });  
  
  $('.layout-filter .heading').on('click', function(e) {
    $('.layout-filter .collection__filter-group').slideToggle();
    e.preventDefault();
  }); 
});

$(document).ready(function() {
  function equalProductGallery() {
    var productGallery = $('.product-block-list__item--gallery .card').height();
    var productItenInfo = $('.product-block-list__item--info .item-info-card').height();
    if(productItenInfo > productGallery){
      $('.product-block-list__item--gallery .product-gallery-card').css('min-height', productItenInfo+'px');
    }
    else {
      $('.product-block-list__item--info .item-info-card').css('min-height', productGallery+'px');
    }
  };

  function equalProductTrust() {
    var productTrust = $('.product-block-list__item--trust').height();
    var totalReviewsHeight = productTrust - 30;
    $('.product-block-list__item--info .review-card').css('min-height', totalReviewsHeight+'px');
  };

  if($(window).width() >= '1000'){
    setTimeout(function(){
      var productBlockList = $('.product-block-list').height();
      $('.product-block-list').css('min-height', productBlockList+'px');
      
      equalProductGallery();
      equalProductTrust();
    }, 1000);
  }
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();
    console.log("scroll");
    if (scroll >= 10) {
      $("body").addClass("mob-img-fixed");
    } else {
      $("body").removeClass("mob-img-fixed");
    }
  });
});

$(window).resize(function(){
  function equalProductGallery() {
    var productGallery = $('.product-block-list__item--gallery .card').height();
    var productItenInfo = $('.product-block-list__item--info .item-info-card').height();
    if(productItenInfo > productGallery){
      $('.product-block-list__item--gallery .product-gallery-card').css('min-height', productItenInfo+'px');
    }
    else {
      $('.product-block-list__item--info .item-info-card').css('min-height', productGallery+'px');
    }
  };

  function equalProductTrust() {
    var productTrust = $('.product-block-list__item--trust').height();
    var totalReviewsHeight = productTrust - 30;
    $('.product-block-list__item--info .review-card').css('min-height', totalReviewsHeight+'px');
  };

  if($(window).width() >= '1000'){
    setTimeout(function(){
      var productBlockList = $('.product-block-list').height();
      $('.product-block-list').css('min-height', productBlockList+'px');
      
      equalProductGallery();
      equalProductTrust();
    }, 1000);
  }
});
